import Component from './Component/Component';
import TextModule from './Modules/Text/TextModule';
import ImageModule from './Modules/Image/ImageModule';
import SVGModule from './Modules/SVG/SVGModule';
import { createComponent } from './Component';
import DefaultModule from './Modules/Default/DefaultModule';
import CaptionModule from './Modules/Caption/CaptionModule';
let modules = [];
export function declareComponents(components) {
    return function (constructor) {
        return class extends constructor {
            validComponents = components;
        };
    };
}
export const getEditorModules = (element) => {
    const component = createComponent(element);
    if (!(component instanceof Component)) {
        throw 'Only Valid components can be used.';
    }
    return modules.filter(module => module.validComponents ? module.validComponents.includes(component.constructor) : []);
};
export const registerModule = (m) => {
    modules.push(m);
};
// defaults
const defaultModules = [TextModule, ImageModule, SVGModule, DefaultModule, CaptionModule];
defaultModules.forEach(module => registerModule(new module()));
// export const initializeToolbar = () => {
//   modules = [];
//   defaultModules.forEach((module) => registerModule(new module()));
// };
